import statusTypes from '../../../support/statusTypes';
import {
  PREMIUM_ACCESS_TYPE,
  EASY_ACCESS_TYPE,
  type BatchAgreement,
  type PremiumAccessAgreementSummary,
} from './types';

// Don't rely on the backend's own ordering; stable sort preserves relative
// order within each priority group.
const AGREEMENT_ORDER_PRIORITY: Record<string, number> = {
  [PREMIUM_ACCESS_TYPE]: 1,
  [EASY_ACCESS_TYPE]: 2,
};

export const withCanonicalAgreementOrder = (
  agreements: BatchAgreement[]
): BatchAgreement[] =>
  [...agreements].sort(
    (a, b) =>
      (AGREEMENT_ORDER_PRIORITY[a.productType] ?? 0) -
      (AGREEMENT_ORDER_PRIORITY[b.productType] ?? 0)
  );

// Puts the currently-selected (default) PA agreement first in the picker,
// stable otherwise. `preferredId` is undefined when there's no current PA
// agreement yet, in which case the input order passes through unchanged.
export const withPreferredPaFirst = (
  agreements: PremiumAccessAgreementSummary[],
  preferredId: number | undefined
): PremiumAccessAgreementSummary[] =>
  [...agreements].sort(
    (a, b) => Number(b.id === preferredId) - Number(a.id === preferredId)
  );

export const getIsSingleAgreement = ({
  batchAgreements,
  showPaPicker,
  availablePaCount,
  hasCurrentPaAgreement,
}: {
  batchAgreements: BatchAgreement[];
  showPaPicker: boolean;
  availablePaCount: number;
  hasCurrentPaAgreement: boolean;
}): boolean => {
  let paRowCount = 0;
  if (showPaPicker) {
    paRowCount = availablePaCount;
  } else if (hasCurrentPaAgreement) {
    paRowCount = 1;
  }
  const nonPaRowCount = batchAgreements.filter(
    (agreement) => agreement.productType !== PREMIUM_ACCESS_TYPE
  ).length;
  return batchAgreements.length >= 1 && paRowCount + nonPaRowCount <= 1;
};

export const getCanEditAgreementSelection = (status: string): boolean =>
  status === statusTypes.IN_PROGRESS;
